import {makeAutoObservable} from 'mobx';
import {TitleSummaryTemplate} from '../../entity/model/title-summary-template';
import {RequestBody} from '../../entity/core/request-body';
import TitleSummaryTemplateAgent from '../agent/title-summary-template-agent';

export default class TitleSummaryTemplateStore {
  titleSummaryTemplateAgent: TitleSummaryTemplateAgent;
  titleSummaryTemplates: TitleSummaryTemplate[] = [];
  cache: boolean = false;

  constructor(titleSummaryTemplateAgent: TitleSummaryTemplateAgent) {
    makeAutoObservable(this);
    this.titleSummaryTemplateAgent = titleSummaryTemplateAgent;
  }

  getTitleSummaryTemplates = async (organizationId: string): Promise<TitleSummaryTemplate[]> => {
    try {
      this.titleSummaryTemplates = await this.titleSummaryTemplateAgent.getTitleSummaryTemplates(organizationId);
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading title summary templates', error);
    }

    return this.titleSummaryTemplates;
  }

  createTitleSummaryTemplate = async (organizationId: string, requestBody: RequestBody): Promise<TitleSummaryTemplate | string> => {
    try {
      const result = await this.titleSummaryTemplateAgent.createTitleSummaryTemplate(organizationId, requestBody);
      this.cache = false;
      return result;
    } catch (error: any) {
      console.error('Error occurred while creating title summary template', error);
      return 'Error occurred while creating title summary template !!';
    }
  }
} 